import {
  EDIT_PROFILE_SET_STATE,
  EDIT_PROFILE_UPDATE_FIELD,
  TECH_PROFILE_GET_DATA_BY_USERNAME_FAIL,
  TECH_PROFILE_GET_DATA_BY_USERNAME_REQUEST,
  TECH_PROFILE_GET_DATA_BY_USERNAME_SUCCESS,
  TECH_PROFILE_GET_PREVIOUS_DATA_FAIL,
  TECH_PROFILE_GET_PREVIOUS_DATA_REQUEST,
  TECH_PROFILE_GET_PREVIOUS_DATA_RESET,
  TECH_PROFILE_GET_PREVIOUS_DATA_SUCCESS,
  TECH_PROFILE_LINK_CHANGES,
  TECH_PROFILE_PUBLISH_FAIL,
  TECH_PROFILE_PUBLISH_REQUEST,
  TECH_PROFILE_PUBLISH_RESET,
  TECH_PROFILE_PUBLISH_SUCCESS,
  TECH_PROFILE_SCROLL_TO_SECTION,
  TECH_PROFILE_USERNAME_CHECK_FAIL,
  TECH_PROFILE_USERNAME_CHECK_REQUEST,
  TECH_PROFILE_USERNAME_CHECK_RESET,
  TECH_PROFILE_USERNAME_CHECK_SUCCESS,
} from "../../constants/MyTechProfile/myTechprofileConstants";

export const EditMyTechProfileReducer = (
  state = {
    loading: false,
    success: false,
    error: null,
    profile: {
      name: "",
      title: "",
      selectedSkills: [],
      projects: [],
      certificates: [],
    },
  },
  action
) => {
  switch (action.type) {
    case EDIT_PROFILE_SET_STATE:
      return {
        ...state,
        profile: action.payload,
      };
    case EDIT_PROFILE_UPDATE_FIELD:
      return {
        ...state,
        profile: {
          ...state.profile,
          [action.payload.field]: action.payload.value,
        },
      };
    default:
      return state;
  }
};

export const TechProfileScrollToSpecificContentReducer = (
  state = { sectionToScroll: "" },
  action
) => {
  if (action.type === TECH_PROFILE_SCROLL_TO_SECTION) {
    return {
      sectionToScroll: action.payload,
    };
  }
  return state;
};
export const TechProfileLinkChangesReducer = (
  state = { linkChangedFor: "" },
  action
) => {
  if (action.type === TECH_PROFILE_LINK_CHANGES) {
    return {
      linkChangedFor: action.payload,
    };
  }
  return state;
};

export const TechProfilePublishReducer = (state = {}, action) => {
  switch (action.type) {
    case TECH_PROFILE_PUBLISH_REQUEST:
      return { loading: true };
    case TECH_PROFILE_PUBLISH_SUCCESS:
      return { loading: false, success: true, publishedData: action.payload };
    case TECH_PROFILE_PUBLISH_FAIL:
      return { loading: false, error: action.payload };
    case TECH_PROFILE_PUBLISH_RESET:
      return {};
    default:
      return state;
  }
};

export const TechProfileUsernameCheckReducer = (state = {}, action) => {
  switch (action.type) {
    case TECH_PROFILE_USERNAME_CHECK_REQUEST:
      return { loading: true };
    case TECH_PROFILE_USERNAME_CHECK_SUCCESS:
      return { loading: false, success: true, usernameDetails: action.payload };
    case TECH_PROFILE_USERNAME_CHECK_FAIL:
      return { loading: false, error: action.payload };
    case TECH_PROFILE_USERNAME_CHECK_RESET:
      return {};
    default:
      return state;
  }
};

export const TechProfileGetDataByUsernameReducer = (state = {}, action) => {
  switch (action.type) {
    case TECH_PROFILE_GET_DATA_BY_USERNAME_REQUEST:
      return { loading: true };
    case TECH_PROFILE_GET_DATA_BY_USERNAME_SUCCESS:
      return { loading: false, success: true, userData: action.payload };
    case TECH_PROFILE_GET_DATA_BY_USERNAME_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const TechProfileGetPreviousDataReducer = (state = {}, action) => {
  switch (action.type) {
    case TECH_PROFILE_GET_PREVIOUS_DATA_REQUEST:
      return { loading: true };
    case TECH_PROFILE_GET_PREVIOUS_DATA_SUCCESS:
      return { loading: false, success: true, userData: action.payload };
    case TECH_PROFILE_GET_PREVIOUS_DATA_FAIL:
      return { loading: false, error: action.payload };
    case TECH_PROFILE_GET_PREVIOUS_DATA_RESET:
      return {};
    default:
      return state;
  }
};
